import { useSelector, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';

import Gadget from 'Modules/devices/.components/dailyDeviceAudit/.components/generalGadget';
import InputDate from 'Components/InputDate';
import { Select, Loading } from "@gpstrackit/react-controls";
import { Grid } from '@mui/material';

//Helpers
import { getDateRange } from 'Core/data/Helpers';

//Actions
import { dailyDeviceAuditRequest, clearRedux } from 'Redux/actions';

//Styles
import './index.scss';
const DailyDeviceAudit = (props) => {
    const { deviceId } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const optionsTimeMetric = [
        { id: `thisweek`, name: messages['dashboard_gadget_thisweek'] },
        { id: `lastweek`, name: messages['dashboard_gadget_lastweek'] },
        { id: `thismonth`, name: messages['dashboard_gadget_this_month'] },
        { id: `lastmonth`, name: messages['dashboard_gadget_last_month'] },
        { id: `last7days`, name: messages['dashboard_gadget_last7days'] },
        { id: `last15days`, name: messages['dashboard_gadget_last15days'] },
        { id: `custom`, name: messages['dashboard_gadget_custom'] },
    ];

    const current_week = moment().startOf('week');
    const tempStartDate = new Date(current_week.toString());


    //Redux States
    const { result, loading } = useSelector(state => state.dailyDeviceAuditRedux)

    //Local States
    const [startDate, setStartDate] = useState(moment().day(0).startOf('day').toDate());
    const [endDate, setEndDate] = useState(moment.max(moment()).toDate());
    const [timeMetric, setTimeMetric] = useState(optionsTimeMetric[4]);
    const [labels, setLabels] = useState([]);
    const [data, setData] = useState({});

    const [beforeRangeDate, setBeforeRangeDate] = useState({ start: tempStartDate, end: endDate })

    const onChangeStartEndDate = ({ start, end }) => {
        const newStart = start && new Date(start);
        const newEnd = end && new Date(end);
        setStartDate(newStart);
        setEndDate(newEnd);
    }

    const onCloseSelectDate = () => {
        const { start, end } = beforeRangeDate;
        if (start && end && !endDate) {
            setStartDate(start);
            setEndDate(end);
        }
    }

    const onChange = (value) => {
        const { start, end } = value;
        onChangeStartEndDate({
            start,
            end
        })
    };

    useEffect(() => {
        if (result) {
            try {
                let info = JSON.parse(result)
                setLabels(info?.labels || {})
                setData(info?.data || {})
            } catch (error) { }
            dispatch(clearRedux("DAILY_DEVICE_AUDIT", { result: null }))
        }
    }, [result])

    useEffect(() => {
        if (timeMetric?.id !== "custom") {
            const range = getDateRange(timeMetric.id)
            let curremtStartDate = moment(range?.startDate).format('YYYY-MM-DD');
            let currentEndDate = moment(range?.endDate).format('YYYY-MM-DD');
            let filters = {
                deviceId,
                range: {
                    startDate: curremtStartDate,
                    endDate: currentEndDate
                }
            }
            dispatch(dailyDeviceAuditRequest(filters))
        } else {
            if (startDate && endDate) {
                let curremtStartDate = moment(startDate).format('YYYY-MM-DD');
                let currentEndDate = moment(endDate).format('YYYY-MM-DD');
                let filters = {
                    deviceId,
                    range: {
                        startDate: curremtStartDate,
                        endDate: currentEndDate
                    }
                }
                dispatch(dailyDeviceAuditRequest(filters))
            }
        }
    }, [timeMetric, startDate, endDate])

    return (
        <div>
            {loading && <Loading overlay show />}
            <Grid container justifyContent="end" spacing={1}>
                <Grid item xs={2} style={{ marginTop: 5 }}>
                    <Select
                        id="timeMetric"
                        placeholder={messages['dashboard_gadget_time_metric']}
                        options={optionsTimeMetric}
                        textField="name"
                        valueField="id"
                        isSearchable={false}
                        value={timeMetric}
                        onChange={(value) => setTimeMetric(value)}
                        required
                        requiredMessage={messages['required_field']}
                    />
                </Grid>
                {
                    timeMetric?.id === "custom" &&
                    <Grid item xs={"auto"} style={{ marginTop: 5 }}>
                        <InputDate
                            id="input-date-range"
                            type="range"
                            onChange={onChange}
                            onClose={onCloseSelectDate}
                            value={startDate}
                            valueEnd={endDate}
                            maxDate={new Date()}
                        />
                    </Grid>
                }
            </Grid>
            <div className="daily-device-audit-container">
                <div className="daily-device-audit-item">
                    <Gadget
                        title={messages['gadget_maintenance_warnigs']}
                        labels={labels}
                        data={data?.maintenanceWarnings || []}
                        color="#ff0000"
                    />
                </div>
                <div className="daily-device-audit-item">
                    <Gadget
                        title={messages['gadget_late_event_count']}
                        labels={labels}
                        data={data?.lateEventCount || []}
                        color="#0d6efd"
                    />
                </div>
                <div className="daily-device-audit-item">
                    <Gadget
                        title={messages['gadget_low_total_event_count']}
                        labels={labels}
                        data={data?.totalEventCount || []}
                        color="#9c27b0"
                    />
                </div>
                <div className="daily-device-audit-item">
                    <Gadget
                        title={messages['gadget_low_maintenance_limit_exceeded_count']}
                        labels={labels}
                        data={data?.maintenanceLimitExceededCount || []}
                        color="#35da13"
                    />
                </div>
                <div className="daily-device-audit-item">
                    <Gadget
                        title={messages['gadget_average_wireless_strength']}
                        labels={labels}
                        data={data?.averageWirelessStrength || []}
                        color="#42eebb"
                    />
                </div>
                <div className="daily-device-audit-item">
                    <Gadget
                        title={messages['gadget_daily_device_vin_count']}
                        labels={labels}
                        data={data?.dailyDeviceVINCount || []}
                        color="#0d6efd"
                    />
                </div>
                <div className="daily-device-audit-item">
                    <Gadget
                        title={messages['gadget_average_hdop']}
                        labels={labels}
                        data={data?.averageHdop || []}
                        color="#66bb6a"
                    />
                </div>
                <div className="daily-device-audit-item">
                    <Gadget
                        title={messages['gadget_average_satellite_count']}
                        labels={labels}
                        data={data?.averageSatelliteCount || []}
                        color="#ffc107"
                    />
                </div>
                <div className="daily-device-audit-item">
                    <Gadget
                        title={messages['gadget_ignition_on_event_count']}
                        labels={labels}
                        data={data?.ignitionOnEventCount || []}
                        color="#0dcaf0"
                    />
                </div>
                <div className="daily-device-audit-item">
                    <Gadget
                        title={messages['gadget_max_min_odometer_difference']}
                        labels={labels}
                        data={data?.maxMinOdometerDifference || []}
                        color="#795548"
                    />
                </div>
                <div className="daily-device-audit-item">
                    <Gadget
                        title={messages['gadget_power_disconnect_event_count']}
                        labels={labels}
                        data={data?.powerDisconnectEventCount || []}
                        color="#009688"
                    />
                </div>
                <div className="daily-device-audit-item">
                    <Gadget
                        title={messages['gadget_low_battery_event_count']}
                        labels={labels}
                        data={data?.lowBatteryEventCount || []}
                        color="#cced0a"
                    />
                </div>
            </div>
        </div>

    )
}
export default DailyDeviceAudit